export const tooltipAlternatifBank = `İş birliği kapsamında, Alternatif Bank gayrimenkulleri Emlakjet emlak ofisleri aracılığıyla satılmaktadır.`;
